import { Icon } from 'Icon'
import LazyLoad from 'react-lazyload'
import useContextMenu from 'hooks/useContextMenu';
import ContextMenu from 'components/ContextMenu';
import {MainContext, useContext} from 'mainContext';

export default function Album({ album, options = {} }) {

    const { currentSong, setCurrentSong } = useContext(MainContext)

    options = {
        bg: true,
        play: true,
        lineClamp: 2,
        coverRounded: false,
        placeholder: 'music',
        placeholderSize: 160,
        ...options
    }

    const { menuRef, anchorPoint, show, setShow, position, setHeight } = useContextMenu();

    const menu = [
        [
            {
                title: 'Add to queue'
            },
            {
                title: 'Go to playlist radio'
            },
            {
                title: 'Add to profile'
            }
        ],
        [
            {
                title: 'Edit details'
            },
            {
                title: 'Delete'
            }
        ],
        [
            {
                title: 'Share'
            },
            {
                title: 'Open in Desktop App'
            }
        ]
    ]

    return (
        <div ref={menuRef} className={`${options.bg ? 'bg-opacity-[0.03]' : 'bg-opacity-0'} bg-white relative transition-all hover:bg-opacity-10 group rounded p-4`}>
            {show && <ContextMenu menu={menu} anchorPoint={anchorPoint} close={setShow} position={position} setHeight={setHeight} />}
            <div className="pb-[100%] w-full relative mb-4 rounded">
                {album.cover && (
                    <LazyLoad scrollContainer=".main-container" offset={100}>
                        <img src={album.cover} className={`w-full h-full bg-white bg-opacity-10 object-cover shadow-spotify-shadow absolute inset-0 ${options.coverRounded ? 'rounded-full' : ''}`} />
                    </LazyLoad>
                )}
                {!album.cover && (
                    <div className={`w-full h-full object-cover absolute inset-0 bg-white bg-opacity-[0.1] flex items-center justify-center shadow-spotify-shadow ${options.coverRounded ? 'rounded-full' : ''}`}>
                        <Icon src={options.placeholder} size={options.placeholderSize} className="text-white text-opacity-80" />
                    </div>
                )}
                {options.play && (
                    <button onClick={() => setCurrentSong(album)} className={`absolute bottom-2 right-2 z-[1] w-10 h-10 rounded-full bg-spotify-green flex items-center justify-center shadow-spotify-shadow transform ${currentSong?.id !== album.id ? 'scale-95 group-hover:scale-100 opacity-0 group-hover:opacity-100' : ''} transition-all hover:!scale-105`}>

                        {currentSong?.id === album.id && <Icon src="pause" size={16} className="text-white text-opacity-80" />}
                        {currentSong?.id !== album.id && <Icon src="play" size={16} className="text-white text-opacity-80" />}

                    </button>
                )}
            </div>
            <div className="font-bold text-white line-clamp-1">{album.name}</div>
            <div className={`text-sm mt-1 line-clamp-${options.lineClamp} text-white text-opacity-60`}>{album.description}</div>
        </div>
    )
}
